import Vue from 'vue';

// When the request succeeds
const success = (response, context) => {
  toastr.success(context.$t('automation.index.status_change_success'));
};

// When the request fails
const failed = (error, context) => {
  context.showToasterError(error);
  context.loading = false;
};

export default (context, actionId, actionStatus) => Vue.$http.post(`/actions/change-status/${actionId}`, { status: actionStatus })
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context);
      } else {
        failed();
      }
    })
    .catch((error) => {
      failed(error, context);
    });



// WEBPACK FOOTER //
// ./src/app/services/automation/changeStatus.js